module.exports = __webpack_public_path__ + "img/bank-transfer.1ed85569.svg";